export default __webpack_public_path__ + "static/The Home_Image 4_carousel 7@2x-1da98922ca7cfbf0b3a48d37779ea0e3.jpg";